import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const ItemIdsSection = ({ onUpdate, boostInput = false, field = 'item_id' }) => {
  const [currentItemIds, setCurrentItemIds] = useState('');
  const [boost, setBoost] = useState(1);

  const handleItemAction = (actionType) => {
    if (!currentItemIds.trim()) return;

    const itemIdsArray = currentItemIds.split(',').map(id => id.trim()).filter(id => id);
    if (itemIdsArray.length === 0) return;

    const updateData = {
      action: actionType,
      filter: 'terms',
      field,
      value: itemIdsArray
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    setCurrentItemIds(''); // Reset after adding
  };

  return (
    <Box>
      <TextField
        label="Item IDs"
        value={currentItemIds}
        onChange={(e) => setCurrentItemIds(e.target.value)}
        placeholder="Enter comma-separated item IDs"
        helperText="e.g., 123, 456, 789"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleItemAction('include')}
          disabled={!currentItemIds.trim()}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleItemAction('boost')}
            disabled={!currentItemIds.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleItemAction('exclude')}
          disabled={!currentItemIds.trim()}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default ItemIdsSection;

